import styled from 'styled-components'
import { getDropdownListStyles } from '../style'

const StyledDropdownList = styled.div`
    ${getDropdownListStyles}
`

export default StyledDropdownList
